import React from 'react';

import type { StatusChipProps } from '~/components/core/StatusChipCore';
import StatusChipCore from '~/components/core/StatusChipCore';
import { CheckIcon, ClockIcon, InProgressIcon, RejectedIcon, WarningCircleIcon } from '~/components/icons';

import TEXTS from '../texts';
import { SorIssueStatus } from '../types';

const STATUS_CHIPS: Record<SorIssueStatus, Pick<StatusChipProps, 'Icon' | 'color'>> = {
  [SorIssueStatus.NeedsAttention]: { Icon: WarningCircleIcon, color: 'orange' },
  [SorIssueStatus.Pending]: { Icon: ClockIcon, color: 'blue' },
  [SorIssueStatus.RemoteDone]: { Icon: InProgressIcon, color: 'lightBlue' },
  [SorIssueStatus.Completed]: { Icon: CheckIcon, color: 'green' },
  [SorIssueStatus.Failed]: { Icon: RejectedIcon, color: 'red' },
};

const SorIssueStatusChip: React.FC<{ status: SorIssueStatus }> = ({ status }) => (
  <StatusChipCore
    status={TEXTS.issueStatuses[status]}
    Icon={STATUS_CHIPS[status].Icon}
    color={STATUS_CHIPS[status].color}
  />
);

export default SorIssueStatusChip;
